<template>
  <div class="app-root" ref="root">
    <router-view></router-view>
    <!-- setting drawer -->
    <v-navigation-drawer class="setting-drawer" temporary v-model="showSidebar">
      <theme-settings></theme-settings>
    </v-navigation-drawer>
    <!-- global snackbar -->
    <v-snackbar :timeout="3000" bottom right :color="snackbar.color" v-model="snackbar.show">
      {{ snackbar.text }}
      <v-btn dark flat @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import ThemeSettings from '@/components/ThemeSettings'

export default {
  components: {
    ThemeSettings,
  },
  data() {
    return {
      showSidebar: false,
      snackbar: {
        show: false,
        text: '',
        color: '',
      },
    }
  },
  mounted() {
    try {
      this.$refs.root.addEventListener('contextmenu', (event) => {
        event.preventDefault()
      })

      this.$store.dispatch('settings/getConfig', {
        callback: () => {
          this.$store.dispatch('settings/getStationId')
          this.$store.dispatch('settings/getSelectedPrinterName')
          this.$store.dispatch('settings/getWindaveUat')
          this.$store.dispatch('time/startNowTimer')
        },
      })
    } catch (error) {
      console.log(error)
    }
  },
  methods: {
    openThemeSettings() {
      this.$vuetify.goTo(0)
    },
  },
}
</script>

<style>
h2 {
  color: gray;
}

h3 {
  color: cadetblue;
}

h4 {
  color: lightslategray;
}

.v-chip span {
  font-size: 26px;
}

.v-text-field input {
  font-size: 1.4em;
  padding: 12px 2px !important;
  margin: 10px 0 !important;
}

.v-btn__content {
  font-size: 1.6em;
}
</style>
